import React from 'react';

const colorArray = (array, coloredTickCount, defaultCount, totalCount) =>
  array.map(El => {
    let key = El.key;

    if (key > totalCount - defaultCount) {
      return React.cloneElement(El, {
        className: 'default-tick',
      });
    }

    if (key > coloredTickCount || coloredTickCount === 0) {
      return React.cloneElement(El, {
        className: 'colored-tick',
      });
    }

    return El;
  });

const speedometerPainter = ({ percent, minPercent, ...props }) => {
  let array1 = [
    <path
      className="tick"
      key="21"
      d="M201.011,231.726l6.7-36.279q-1.521-.28-3.049-.53l-5.933,36.4C199.5,231.439,200.252,231.588,201.011,231.726Z"
      transform="translate(-33.294 -192.982)"
    />,
    <path
      className="tick"
      key="22"
      d="M207.341,233l9.794-35.529q-1.479-.408-2.97-.786L205.1,232.4C205.852,232.588,206.6,232.795,207.341,233Z"
      transform="translate(-30.305 -192.153)"
    />,
    <path
      className="tick"
      key="16"
      d="M171.911,232.653l-9.034-36.033q-1.5.375-2.98.78l9.791,35.884C170.428,233.074,171.163,232.847,171.911,232.653Z"
      transform="translate(-51.523 -192.182)"
    />,
    <path
      className="tick"
      key="20"
      d="M194.582,230.906l3.557-36.75q-1.53-.148-3.064-.264l-2.8,36.838C193.043,230.784,193.815,230.836,194.582,230.906Z"
      transform="translate(-36.326 -193.463)"
    />,
    <path
      className="tick"
      key="23"
      d="M213.523,234.724l12.828-34.5q-1.448-.538-2.908-1.046l-12.112,34.788C212.061,234.219,212.8,234.457,213.523,234.724Z"
      transform="translate(-27.38 -190.982)"
    />,
    <path
      className="tick"
      key="17"
      d="M177.267,231.507,171.4,194.875q-1.527.245-3.045.522l6.637,36.518Q176.124,231.7,177.267,231.507Z"
      transform="translate(-47.553 -193.002)"
    />,
    <path
      className="tick"
      key="18"
      d="M182.714,230.814l-2.708-36.941q-1.552.112-3.093.26l3.5,36.856C181.171,230.912,181.947,230.875,182.714,230.814Z"
      transform="translate(-43.536 -193.472)"
    />,
    <path
      className="tick"
      key="19"
      d="M187.549,230.554c.222,0,.442.015.664.016l.426-36.961c-.573-.006-1.145-.009-1.719-.009l-1.4.007L185.9,230.6C186.452,230.588,187,230.554,187.549,230.554Z"
      transform="translate(-39.497 -193.6)"
    />,
    <path
      className="tick"
      key="28"
      d="M240.478,249.811l26.08-25.947q-1.1-1.1-2.213-2.176L238.813,248.2C239.368,248.735,239.934,249.263,240.478,249.811Z"
      transform="translate(-14.48 -180.416)"
    />,
    <path
      className="tick"
      key="24"
      d="M219.477,236.925l15.777-33.248q-1.4-.661-2.808-1.3l-15.073,33.592C218.075,236.287,218.782,236.6,219.477,236.925Z"
      transform="translate(-24.544 -189.478)"
    />,
    <path
      className="tick"
      key="31"
      d="M252.123,263.064l31.906-18.442q-.782-1.353-1.591-2.688l-31.472,19.118C251.367,261.714,251.738,262.394,252.123,263.064Z"
      transform="translate(-8.775 -170.912)"
    />,
    <path
      className="tick"
      key="30"
      d="M248.7,258.377l30.192-21.1q-.9-1.294-1.838-2.569l-29.7,21.776Q248.037,257.423,248.7,258.377Z"
      transform="translate(-10.47 -174.302)"
    />,
    <path
      className="tick"
      key="25"
      d="M225.189,239.564,243.774,207.8q-1.336-.782-2.692-1.536l-17.9,32.149C223.859,238.787,224.524,239.176,225.189,239.564Z"
      transform="translate(-21.816 -187.656)"
    />,
    <path
      className="tick"
      key="26"
      d="M230.616,242.6l21.24-30.054q-1.248-.882-2.514-1.74l-20.614,30.45C229.369,241.693,229.986,242.156,230.616,242.6Z"
      transform="translate(-19.214 -185.522)"
    />,
    <path
      className="tick"
      key="27"
      d="M235.728,246.028l23.735-28.118q-1.17-.987-2.358-1.95l-23.159,28.587C234.547,245.034,235.138,245.529,235.728,246.028Z"
      transform="translate(-16.764 -183.104)"
    />,
    <path
      className="tick"
      key="29"
      d="M244.812,253.933,273.025,230.3q-.981-1.173-1.987-2.325l-27.745,24.205C243.8,252.762,244.316,253.339,244.812,253.933Z"
      transform="translate(-12.377 -177.465)"
    />,
    <path
      className="tick"
      key="5"
      d="M128.74,271.191,93.3,257.343q-.566,1.446-1.1,2.909l35.73,13.081C128.188,272.613,128.467,271.9,128.74,271.191Z"
      transform="translate(-83.3 -163.679)"
    />,
    <path
      className="tick"
      key="4"
      d="M126.982,276.279l-36.576-10.69q-.434,1.481-.836,2.976l36.786,9.918C126.552,277.742,126.771,277.012,126.982,276.279Z"
      transform="translate(-84.534 -159.808)"
    />,
    <path
      className="tick"
      key="6"
      d="M130.915,266.255,96.889,249.4q-.692,1.4-1.356,2.815l34.424,16.113C130.275,267.637,130.581,266.94,130.915,266.255Z"
      transform="translate(-81.735 -167.408)"
    />,
    <path
      className="tick"
      key="1"
      d="M124.366,292.153l-38.185-.876q-.035,1.543-.038,3.095l38.166.069C124.309,293.674,124.35,292.917,124.366,292.153Z"
      transform="translate(-86.143 -147.751)"
    />,
    <path
      className="tick"
      key="7"
      d="M133.529,261.508l-32.394-19.694q-.8,1.325-1.581,2.667l32.834,19.011C132.765,262.829,133.137,262.162,133.529,261.508Z"
      transform="translate(-79.848 -170.968)"
    />,
    <path
      className="tick"
      key="3"
      d="M125.648,281.49l-37.4-7.453q-.3,1.519-.573,3.051l37.57,6.656C125.376,282.992,125.5,282.236,125.648,281.49Z"
      transform="translate(-85.423 -155.843)"
    />,
    <path
      className="tick"
      key="2"
      d="M124.767,286.792l-37.927-4.167q-.167,1.527-.306,3.064l38.028,3.384C124.628,288.312,124.686,287.549,124.767,286.792Z"
      transform="translate(-85.959 -151.812)"
    />,
    <path
      className="tick"
      key="15"
      d="M166.7,234.3,154.55,199.1q-1.481.511-2.951,1.055L164.53,235.1Q165.612,234.688,166.7,234.3Z"
      transform="translate(-55.418 -191.021)"
    />,
    <path
      className="tick"
      key="12"
      d="M152.108,241.8l-20.949-31.1q-1.287.866-2.555,1.762l21.624,30.672C150.851,242.689,151.473,242.238,152.108,241.8Z"
      transform="translate(-66.212 -185.571)"
    />,
    <path
      className="tick"
      key="13"
      d="M156.747,238.894l-18.154-32.719q-1.349.745-2.676,1.521l18.827,32.35C155.406,239.652,156.077,239.273,156.747,238.894Z"
      transform="translate(-62.779 -187.697)"
    />,
    <path
      className="tick"
      key="14"
      d="M161.626,236.385,146.4,202.295q-1.413.63-2.808,1.29l15.924,33.758C160.212,237.008,160.925,236.707,161.626,236.385Z"
      transform="translate(-59.175 -189.519)"
    />,
    <path
      className="tick"
      key="8"
      d="M136.538,257l-30.514-22.391q-.906,1.232-1.784,2.485l30.966,21.777C135.644,258.238,136.09,257.617,136.538,257Z"
      transform="translate(-77.648 -174.352)"
    />,
    <path
      className="tick"
      key="11"
      d="M147.725,245.088l-23.6-29.232q-1.2.968-2.379,1.962l24.23,28.774C146.56,246.09,147.131,245.578,147.725,245.088Z"
      transform="translate(-69.431 -183.153)"
    />,
    <path
      className="tick"
      key="9"
      d="M139.935,252.733,111.521,227.85q-1.02,1.166-2.019,2.355l28.93,24.264C138.919,253.879,139.435,253.313,139.935,252.733Z"
      transform="translate(-75.178 -177.523)"
    />,
    <path
      className="tick"
      key="10"
      d="M143.666,248.755l-26.1-27.171q-1.111,1.069-2.2,2.159l26.671,26.636C142.574,249.83,143.118,249.291,143.666,248.755Z"
      transform="translate(-72.426 -180.464)"
    />,
  ];

  let array2 = [
    <path
      className="tick"
      key="34"
      d="M259.308,278.02l35.079-9.425q-.405-1.512-.845-3.006l-34.87,10.192C258.889,276.524,259.105,277.269,259.308,278.02Z"
      transform="translate(-251.709 -241.829)"
    />,
    <path
      className="tick"
      key="33"
      d="M257.418,272.723l34.087-12.48q-.529-1.448-1.089-2.882l-33.852,13.194C256.846,271.279,257.15,271.993,257.418,272.723Z"
      transform="translate(-252.698 -245.691)"
    />,
    <path
      className="tick"
      key="32"
      d="M254.944,267.609l32.872-15.454q-.648-1.378-1.318-2.736l-32.565,16.1Q254.449,266.556,254.944,267.609Z"
      transform="translate(-253.933 -249.419)"
    />,
    <path
      className="tick"
      key="37"
      d="M261.7,294.447l36.319-.066q0-1.567-.04-3.127l-36.338.868C261.66,292.9,261.7,293.668,261.7,294.447Z"
      transform="translate(-250.314 -229.782)"
    />,
    <path
      className="tick"
      key="36"
      d="M261.446,288.9l36.2-3.187q-.137-1.538-.3-3.065l-36.112,3.935C261.311,287.349,261.378,288.124,261.446,288.9Z"
      transform="translate(-250.509 -233.822)"
    />,
    <path
      className="tick"
      key="35"
      d="M260.646,283.435l35.786-6.308q-.276-1.561-.585-3.111l-35.609,7.128C260.389,281.9,260.511,282.671,260.646,283.435Z"
      transform="translate(-250.973 -237.873)"
    />,
  ];

  const TICK_COUNT = array1.length + array2.length;

  const coloredTickCount = Math.round((TICK_COUNT * percent) / 100);

  const minimumPercentCount = Math.round((TICK_COUNT * minPercent) / 100);

  array2 = colorArray(
    array2,
    coloredTickCount,
    minimumPercentCount,
    TICK_COUNT
  );
  array1 = colorArray(
    array1,
    coloredTickCount,
    minimumPercentCount,
    TICK_COUNT
  );

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 294.256 146.94"
      height="100%"
      width="100%"
      {...props}
    >
      <defs>
        <style>
          {
            '.tick{fill:#ffffff ;} .colored-tick{fill:#443C38;} .default-tick{fill:#f94b4d;}'
          }
        </style>
      </defs>
      <g transform="translate(44.344 44.111)">
        <path
          className="tick"
          d="M322.692,326.449h-5.878q0-.714-.01-1.427l5.878-.085Q322.693,325.69,322.692,326.449Zm-200.507-6.241-5.864-.379q.049-.754.106-1.5l5.86.458C122.25,319.256,122.216,319.732,122.185,320.208Zm194.28-2.019c-.04-.473-.082-.948-.131-1.418l5.85-.588c.05.5.1,1,.14,1.506Zm-193.4-6.2-5.811-.877c.075-.5.154-.995.235-1.491l5.8.957C123.208,311.046,123.135,311.518,123.063,311.99Zm192.355-2c-.081-.472-.165-.94-.251-1.411l5.779-1.068q.137.738.264,1.483Zm-190.778-6.116-5.716-1.369q.176-.734.364-1.469l5.694,1.456C124.864,302.951,124.751,303.413,124.639,303.874Zm189.031-1.959c-.12-.463-.245-.923-.373-1.383l5.666-1.569q.2.725.392,1.455Zm-186.762-5.986-5.576-1.859q.24-.716.488-1.43l5.55,1.938C127.212,295.027,127.059,295.478,126.908,295.929Zm184.326-1.915c-.162-.448-.323-.895-.489-1.339l5.5-2.065q.267.712.52,1.431Zm-181.386-5.8-5.4-2.33q.3-.692.607-1.377l5.362,2.405Q130.133,287.561,129.848,288.215Zm178.272-1.873q-.293-.644-.6-1.284l5.3-2.539q.331.69.645,1.386Zm-174.675-5.565-5.184-2.771q.357-.668.726-1.328l5.137,2.857Q133.778,280.153,133.445,280.777Zm170.918-1.807q-.348-.619-.708-1.233l5.071-2.974c.257.438.507.877.757,1.32Zm-166.706-5.291-4.924-3.209q.412-.633.836-1.261l4.873,3.286Q138.045,273.082,137.657,273.678Zm162.333-1.727c-.267-.394-.541-.785-.814-1.173l4.8-3.39c.292.411.579.826.864,1.243Zm-157.527-4.994-4.633-3.618q.465-.6.942-1.184l4.576,3.687C143.049,266.212,142.755,266.582,142.463,266.957Zm152.572-1.631q-.452-.553-.91-1.1l4.495-3.788q.487.577.967,1.165Zm-147.212-4.662-4.307-4q.514-.555,1.034-1.1l4.251,4.06Q148.308,260.142,147.823,260.664Zm141.713-1.518q-.494-.514-1-1.018l4.164-4.147q.536.536,1.059,1.077Zm-135.836-4.3-3.957-4.345q.56-.509,1.127-1.012l3.891,4.407Q154.229,254.364,153.7,254.843Zm129.838-1.389q-.538-.469-1.083-.93l3.8-4.483q.573.487,1.143.983Zm-123.493-3.912-3.569-4.67q.6-.458,1.206-.91l3.5,4.718Q160.615,249.108,160.046,249.543Zm117.039-1.252q-.573-.419-1.152-.83l3.4-4.8q.617.439,1.227.885Zm-110.259-3.5-3.168-4.95q.637-.408,1.283-.807l3.093,5Q167.425,244.406,166.826,244.791Zm103.4-1.1q-.613-.37-1.228-.736l2.995-5.056q.646.381,1.287.771Zm-96.244-3.061-2.735-5.2q.67-.353,1.346-.7l2.66,5.243Q174.611,240.3,173.979,240.634Zm89.012-.94q-.633-.315-1.272-.622l2.541-5.3q.686.328,1.361.666Zm-81.525-2.6-2.283-5.415q.7-.3,1.4-.579l2.206,5.449Q182.124,236.817,181.465,237.1Zm73.99-.77q-.663-.262-1.33-.517l2.091-5.493q.708.269,1.408.548Zm-66.23-2.116-1.81-5.593q.719-.231,1.441-.455l1.729,5.617C190.13,233.921,189.676,234.063,189.225,234.21Zm58.422-.6c-.454-.137-.911-.27-1.367-.4l1.609-5.651c.485.137.971.279,1.455.425ZM197.191,232l-1.327-5.725q.734-.172,1.474-.331l1.246,5.744C198.118,231.788,197.654,231.891,197.191,232Zm42.449-.435c-.466-.1-.932-.192-1.4-.284l1.126-5.769c.5.1.987.2,1.48.3Zm-34.324-1.09-.836-5.817q.745-.108,1.494-.2l.757,5.829C206.259,230.342,205.788,230.406,205.317,230.473Zm26.166-.267q-.708-.088-1.422-.165l.645-5.842c.5.056,1,.112,1.5.173Zm-17.934-.566-.354-5.867c.5-.031,1.009-.056,1.515-.078l.259,5.872Q214.256,229.6,213.548,229.64Zm9.692-.1c-.475-.018-.952-.034-1.43-.046l.154-5.876c.5.013,1,.028,1.5.048Z"
          transform="translate(-116.321 -223.62)"
        />
      </g>
      <g transform="translate(0 0)">{array1}</g>
      <g transform="translate(246.55 82.02)">{array2}</g>
    </svg>
  );
};

export default speedometerPainter;
